import { FC, useContext } from 'react'
import { observer } from 'mobx-react'
import { StoreContext } from '@store/Root.store'

interface SignDocumentHintProps {
  show?: boolean
}
export const SignDocumentHintTooltip: FC<SignDocumentHintProps> = observer(({ show }) => {
  const store = useContext(StoreContext)
  const { signDocumentPage: trans } = store.TranslationsState.translationsNew

  if (!show) {
    return <></>
  }

  return (
    <div className="generic__sign-document-hint">
      <svg
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.99996 3.04183C6.15698 3.04183 3.04162 6.15718 3.04162 10.0002C3.04162 13.8431 6.15698 16.9585 9.99996 16.9585C13.8429 16.9585 16.9583 13.8431 16.9583 10.0002C16.9583 6.15718 13.8429 3.04183 9.99996 3.04183ZM1.95829 10.0002C1.95829 5.55887 5.55867 1.9585 9.99996 1.9585C14.4412 1.9585 18.0416 5.55887 18.0416 10.0002C18.0416 14.4415 14.4412 18.0418 9.99996 18.0418C5.55867 18.0418 1.95829 14.4415 1.95829 10.0002Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.99996 14.7085C9.7008 14.7085 9.45829 14.466 9.45829 14.1668L9.45829 9.16683C9.45829 8.86767 9.7008 8.62516 9.99996 8.62516C10.2991 8.62516 10.5416 8.86767 10.5416 9.16683V14.1668C10.5416 14.466 10.2991 14.7085 9.99996 14.7085Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.625 6.4585C10.625 6.11332 10.3451 5.8335 9.99996 5.8335C9.65478 5.8335 9.37496 6.11332 9.37496 6.4585C9.37496 6.80367 9.65478 7.0835 9.99996 7.0835C10.3451 7.0835 10.625 6.80367 10.625 6.4585Z"
          fill="white"
        />
      </svg>
      <div>{trans.hint}</div>
      <div className="generic__tooltip-arrow button--hint-tooltip" data-direction="bottom" />
    </div>
  )
})
